var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0136 14.085C17.0874 12.6186 17.7297 10.8175 17.7297 8.86487C17.7297 3.97695 13.7528 0 8.86484 0C3.97691 0 0 3.97695 0 8.86487C0 13.7528 3.97695 17.7297 8.86488 17.7297C10.8175 17.7297 12.6188 17.0874 14.0852 16.0136L19.8928 21.8211L21.8213 19.8926C21.8213 19.8926 16.0136 14.085 16.0136 14.085ZM8.86488 15.0021C5.48061 15.0021 2.72767 12.2491 2.72767 8.86487C2.72767 5.48061 5.48061 2.72767 8.86488 2.72767C12.2491 2.72767 15.0021 5.48061 15.0021 8.86487C15.0021 12.2491 12.2491 15.0021 8.86488 15.0021Z",
    fill: "#F7F7F7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.afc1c43cd5cf0b0fa8bf0f11876b95c2.svg";
export { ForwardRef as ReactComponent };